export default __webpack_public_path__ + "static/media/finished.ac9ce43e.mp3";